<template>
  <div class="d-flex flex-column mt-4">
    <div class="caution-title">注意事項</div>
    <div class="caution-text text-start py-2 px-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Precautions",
  props: {
  },
  data() {
    return {
    };
  },
  watch: {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.caution-title {
  font-weight: bold;
  color: $text-white-color;
  background-color: $status-error-color;
  border: solid 1px $status-error-color;
  border-radius: 5px 5px 0px 0px;
}

.caution-text {
  font-size: 12px;
  font-weight: bold;
  color: $status-error-color;
  background-color: $background-white-color;
  border: solid 1px $status-error-color;
  border-radius: 0px 0px 5px 5px;
}
</style>
